import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SharedService } from './shared-service';
import { catchError, filter, switchMap, take, throwError } from 'rxjs';
import { UserProfileData } from '../models/user-profile.model';
import { OAuthService } from 'angular-oauth2-oidc';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const sharedService = inject(SharedService);
  const oauthService = inject(OAuthService);
  // const accessToken = sharedService.getAccessToken();
  // const userProfile: UserProfileData | null = sharedService.getUserProfile();

  // const modUser = userProfile?.qxid ?? '';
  // let authenticationRequest = req;
  // authenticationRequest = req.clone({
  //   setHeaders: {
  //     Authorization: `Bearer ${accessToken}`,
  //     modUser: `${modUser}`,
  //   },
  // });

  // return next(authenticationRequest).pipe(
  //   catchError((error: HttpErrorResponse) => {
  //     // if (error.status === 401) sharedService.setAccessToken('');
  //     return throwError(() => error);
  //   })
  // );

  if (
    !/(bmw\.cloud|cloud\.bmw)/i.test(new URL(req.url, location.origin).host)
  ) {
    return next(req);
  }

  return sharedService.userProfile$.pipe(
    filter(Boolean),
    take(1),
    switchMap((userProfile: UserProfileData) => {
      const authenticationRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${userProfile.accessToken}`,
          modUser: `${userProfile.qxid}`,
        },
      });
      return next(authenticationRequest);
    }),
    catchError((error: HttpErrorResponse) => {
      sharedService.logger('Authentication Interceptor error -', error);
      // if (error.status > 400 && error.status < 500) {
      if (error.status === 401 || error.status === 403) {
        oauthService.logOut();
        sharedService.clearStorage();
        // window.location.reload();
      }
      return throwError(() => error);
    })
  );
};
